module.exports = __webpack_public_path__ + "img/portraits_20_V.543227ae.webp";